export default __webpack_public_path__ + "static/media/blue_pressed.76e2ec8c.png";